// export DsfDialog from "./dsfDialog.vue";
export const DsfDialog = Vue.defineAsyncComponent(()=>import(/*webpackChunkName:"platform_pc_dialog"*/'./dsfDialog.vue'));
// export DsfDialogIframe from "./dsfDialogIframe.vue";
export const DsfDialogIframe = Vue.defineAsyncComponent(()=>import(/*webpackChunkName:"platform_pc_dialog"*/'./dsfDialogIframe.vue'));
export const DsfDrawer = Vue.defineAsyncComponent(()=>import(/*webpackChunkName:"platform_pc_dialog"*/'./dsfDrawer.vue'));

